'use client';
import { useEffect } from 'react';
import { Banner } from '@airbus/components-react';
import Spinners from '../../shared/components/Spinner';
import Layout from '../../shared/components/layout';
import useFetchScreenDetails from '../../shared/utils/useFetchScreenDetails';
import GetAllColumnContextProvider, {
  useColumnContextAPI,
} from '../../shared/context/GetAllColumnContext';
import { CommitHandler } from '../../features/makeorbuy/commitHandler';
import {
  MoBActions,
  SetISCellRequired,
  SetIsCellEditable,
  extraValidator,
} from '../../features/makeorbuy';
import MOBSetColumnConfig from '../../features/makeorbuy/components/MOBSetColumnConfig';
import { t } from '../../i18next';
import GridWrapper from '../../shared/components/grid/GridWrapper';
import { setAllDropdowns } from '../../shared/services/allDropdownsRegistry';

const MakeOrBuyPage = () => {
  const { loading, error, screenTables } = useFetchScreenDetails('npi_board');
  return (
    <>
      {loading ? (
        <Spinners />
      ) : (
        <Layout>
          {error && <Banner variant='warning'>{t('data_not_available')}</Banner>}
          {!screenTables
            ? null
            : screenTables.map((item) => (
                <GetAllColumnContextProvider key={item.id}>
                  <MakeOrBuy tableRes={item} />
                </GetAllColumnContextProvider>
              ))}
        </Layout>
      )}
    </>
  );
};

export default MakeOrBuyPage;

const MakeOrBuy = ({ tableRes }) => {
  const { updateCustomConfig, allDropdowns } = useColumnContextAPI();

  useEffect(() => {
    setAllDropdowns(allDropdowns);
  }, [allDropdowns]);

  useEffect(() => {
    updateCustomConfig({
      CommitHandler,
      Actions: MoBActions,
      SetColumnConfig: MOBSetColumnConfig,
      SetISCellRequired,
      SetIsCellEditable,
      extraValidator,
    });
  }, []);

  return <GridWrapper tableRes={tableRes} />;
};
